module.exports = __webpack_public_path__ + "img/pickupdumping_stopped.ad094eb3.svg";